import lodash from 'lodash';

import { TextStyle_TextAlignment } from './../ricos-schema/legacy/wix/rich_content/v1';
import type { CustomTextualStyle } from './../ricos-types';

export const nodeElementStyleToTiptapTextStyle = (nodeStyle: string) => {
  const style: {
    paddingTop?: CustomTextualStyle['paddingTop'];
    paddingBottom?: CustomTextualStyle['paddingBottom'];
  } = {};
  const textStyle: {
    lineHeight?: CustomTextualStyle['lineHeight'];
    textAlignment?: TextStyle_TextAlignment;
  } = {};
  const stylesAsArray = nodeStyle.split(';').map(x => x.split(':'));
  stylesAsArray.forEach(nodeStyle => {
    const nodeStyleKey = nodeStyle[0];
    const nodeStyleValue = nodeStyle[1]?.trim();
    if (nodeStyleKey.includes('line-height')) {
      textStyle.lineHeight = nodeStyleValue;
    } else if (nodeStyleKey.includes('text-align')) {
      const textAlign = nodeStyleValue;
      if (textAlign === 'initial') {
        textStyle.textAlignment = TextStyle_TextAlignment.AUTO;
      } else {
        textStyle.textAlignment = textAlign.toUpperCase() as TextStyle_TextAlignment;
      }
    } else if (nodeStyleKey.includes('padding-top')) {
      style.paddingTop = nodeStyleValue;
    } else if (nodeStyleKey.includes('padding-bottom')) {
      style.paddingBottom = nodeStyleValue;
    }
  });
  return {
    style: lodash.isEmpty(style) ? null : style,
    textStyle: lodash.isEmpty(textStyle) ? null : textStyle,
  };
};
